
import { language as lan_products} from "./products";

//

/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 */
let language = {
    //分类产品列表
    ...lan_products,    
};

export { language }